/**
 * THE SIGHT WEDGES' PACE (the perf overhaul, Stage 1). Each redraw of the wedges rewrites their polygons inside the
 * map's SVG, which repaints the whole map: twenty a second held a laptop's main thread at 28% in idle Stealth. A
 * sweep needs only as many frames as keep its step small, so the pace is set by the fastest sweep on screen - at
 * most STEP_DEG a frame - between twenty frames a second (the cap the wedges always had) and five.
 */

/** The largest turn between two frames, degrees: small enough to read as a sweep, not a tick. */
const STEP_DEG = 3;
const FASTEST_MS = 50;
const SLOWEST_MS = 200;

/** Milliseconds between redraws for sweeps going round once in each of `periodsS` seconds; null when none sweeps. */
export function sweepFrameMs(periodsS: readonly number[]): number | null {
  if (periodsS.length === 0) return null;
  const degreesPerMs = 360 / (Math.min(...periodsS) * 1000);
  return Math.min(SLOWEST_MS, Math.max(FASTEST_MS, Math.round(STEP_DEG / degreesPerMs)));
}
